
























import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator'

@Component
export default class MainSidebar extends Vue {
  data () {
    return {
      links: [
        {
          label: 'About Me',
          to: '/about'
        },
        {
          label: 'Experience',
          to: '/experience'
        },
        {
          label: 'Competencies',
          to: '/competencies'
        },
        {
          label: 'Skills',
          to: '/skills'
        },
        {
          label: 'Goals',
          to: '/goals'
        },
        {
          label: 'Portfolio',
          to: '/portfolio'
        }
      ]
    }
  }
}

